export default __webpack_public_path__ + "static/1-82dc6a29bf67452540cb8b6b0109a710.jpeg";